import Vue from 'vue'
import VueRouter from 'vue-router'
import cookie from 'vue-cookies'

import Home from '@/views/Home/Home.vue'
import History from '@/views/History/History.vue'
import Transfer from '@/views/Transfer/Transfer'
import Payments from '@/views/Payments/Payments.vue'
import TermsOfUse from '@/views/TermsOfUse/TermsOfUse.vue'
import VKAuth from '@/views/VKAuth/VKAuth'
import Referal from '@/views/Referal/Referal'
import Apple from '@/views/Apple/Apple.vue'
import Contacts from '@/views/Contacts/Contacts'
import PrivacyPolicy from '@/views/PrivacyPolicy/PrivacyPolicy'
import NotFound from '@/views/NotFound/NotFound.vue'
import ServiceUnavailable from '@/views/ServiceUnavailable/ServiceUnavailable.vue'

import store from '@/store/index'
import { REDIRECT_ROUTES } from '@/router/const'
import { getRedirectConfig } from '@/router/redirects'
import { PURCHASE_METHODS, resolveLegacyPurchaseRoute } from '@/utils/purchase'

Vue.use(VueRouter)

// Мета лежит в meta ключами i18n, а не готовыми строками: строку пришлось бы
// резолвить на импорте модуля, то есть один раз и на языке первой загрузки.
// Ключ отдаёт App.vue в metaInfo через $t — реактивно и к роуту, и к языку.
// noindex — для служебных роутов (коллбэки авторизации, 404, 503).
// ogTitleKey — только там, где заголовок карточки отличается от title; на
// остальных роутах og:title берёт title, и ключ не нужен.

// Хелпер для парсинга
// const parseRedirect = (template, existingQuery = {}) => {
//   // Разделяем на путь+запрос и хэш
//   const [pathAndQuery, hash] = template.split('#')
//   const [path, queryString] = pathAndQuery.split('?')
//
//   // Моковый base урла, далее используются только query параметры
//   const url = new URL(path + '?' + queryString, 'http://localhost')
//
//   if (hash !== undefined) {
//     url.hash = hash
//   }
//
//   // Добавляем существующие query параметры
//   Object.entries(existingQuery).forEach(([key, value]) => {
//     if (value !== undefined && value !== null) {
//       url.searchParams.set(key, value)
//     }
//   })
//
//   return {
//     path: url.pathname,
//     query: Object.fromEntries(url.searchParams.entries()),
//     hash: url.hash || '',
//     replace: true
//   }
// }
//

const routes = [
  {
    path: '/code',
    name: 'Apple',
    component: Apple,
    meta: {
      auth: -1,
      noindex: true
    }
  },
  {
    path: '/vkauth',
    name: 'VKAuth',
    component: VKAuth,
    props: route => ({ query: route.query.q }),
    meta: {
      auth: -1,
      noindex: true
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      auth: -1,
      titleKey: 'app.title',
      descriptionKey: 'app.description',
      h1Key: 'app.h1'
    }
  },
  {
    path: '/ref/:code',
    name: 'Referal',
    component: Referal,
    meta: {
      auth: -1,
      titleKey: 'app.title',
      descriptionKey: 'app.description',
      // Адресов столько, сколько промокодов, и каждый показывает то же, что
      // главная. Пока путь отдавал 404, робот их не видел; теперь отдаёт 200,
      // и без noindex это была бы фабрика дублей главной с self-canonical на
      // каждом коде. Заодно снимает canonical — см. canonicalHref в App.vue.
      noindex: true
    }
  },
  {
    path: '/history',
    name: 'History',
    component: History,
    meta: {
      auth: 1,
      titleKey: 'app.history.title',
      descriptionKey: 'app.history.description',
      // Аноним сюда не доходит — beforeEach уводит его на `/`, так что робот
      // этот тег не увидит. Для него noindex вешается заголовком X-Robots-Tag
      // в nginx; здесь — чтобы страница была закрыта и у авторизованного.
      noindex: true
    }
  },
  // Снятые методы покупки. Боевой 301 отдаёт nginx (config/nginx.conf.erb,
  // мапа $method_redirect) — клиентский редирект робот не видит, а эти четыре
  // адреса как раз и висели в Вебмастере дублями главной. Здесь — фолбэк для
  // внутренних переходов и dev-сборки, цели те же.
  //
  // Компоненты BuyMethod, LogPass, Premium и FastPass после этого недостижимы.
  // Удалять их отдельной задачей: вместе с ними уйдут ключи i18n app.methods,
  // app.logpass, app.premium, app.fastpass и titlePostfix (см. SEO_BACKLOG п. 9).
  {
    path: '/methods',
    redirect: '/'
  },
  // Продуктовые витрины живут на ЧПУ: query-адреса закрыты `Disallow: /*?`
  // и в индекс не попадали. Метод покупки берётся из meta.method (Transfer.vue).
  {
    path: '/transfer',
    name: 'Purchase',
    component: Transfer,
    meta: {
      auth: -1,
      method: PURCHASE_METHODS.TRANSFER,
      titleKey: 'app.transfer.title',
      descriptionKey: 'app.transfer.description',
      h1Key: 'app.transfer.h1',
      ogTitleKey: 'app.transfer.ogTitle'
    }
  },
  {
    path: '/giftcards',
    name: 'GiftCards',
    component: Transfer,
    meta: {
      auth: -1,
      method: PURCHASE_METHODS.GIFT,
      titleKey: 'app.giftcards.title',
      descriptionKey: 'app.giftcards.description',
      h1Key: 'app.giftcards.h1',
      ogTitleKey: 'app.giftcards.ogTitle'
    }
  },
  {
    path: '/superpass',
    name: 'SuperPass',
    component: Transfer,
    meta: {
      auth: -1,
      method: PURCHASE_METHODS.SUPER_PASS,
      titleKey: 'app.superpass.title',
      descriptionKey: 'app.superpass.description',
      h1Key: 'app.superpass.h1',
      ogTitleKey: 'app.superpass.ogTitle'
    }
  },
  {
    path: '/packs',
    name: 'Packs',
    component: Transfer,
    meta: {
      auth: -1,
      method: PURCHASE_METHODS.PACKS,
      titleKey: 'app.packs.title',
      descriptionKey: 'app.packs.description',
      h1Key: 'app.packs.h1',
      ogTitleKey: 'app.packs.ogTitle'
    }
  },
  // Старый адрес витрин. Боевой 301 отдаёт nginx (config/nginx.conf.erb);
  // здесь — клиентский фолбэк для внутренних переходов и dev-сборки.
  {
    path: '/purchase',
    redirect: to => resolveLegacyPurchaseRoute(to.query)
  },
  {
    path: '/fastpass',
    redirect: '/transfer'
  },
  {
    path: '/logpass',
    redirect: '/packs'
  },
  {
    path: '/premium',
    redirect: '/packs'
  },
  {
    path: '/payment',
    name: 'Payments',
    component: Payments,
    meta: {
      auth: 1,
      titleKey: 'app.payment.title',
      descriptionKey: 'app.payment.description',
      // См. комментарий у /history: роботу noindex приходит из nginx.
      noindex: true
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyPolicy,
    meta: {
      auth: -1,
      titleKey: 'app.privacy.title',
      descriptionKey: 'app.privacy.description'
    }
  },
  {
    path: '/termsofuse',
    name: 'TermsOfUse',
    component: TermsOfUse,
    meta: {
      auth: -1,
      titleKey: 'app.termsofuse.title',
      descriptionKey: 'app.termsofuse.description'
    }
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: Contacts,
    meta: {
      auth: -1,
      titleKey: 'app.contacts.title',
      descriptionKey: 'app.contacts.description'
    }
  },
  {
    path: '/503',
    name: 'ServiceUnavailable',
    component: ServiceUnavailable,
    meta: {
      auth: -1,
      titleKey: 'app.serviceUnavailable.title',
      descriptionKey: 'app.serviceUnavailable.description',
      noindex: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    beforeEnter(to, from, next) {
      // const path = to.path.slice(1)
      // const firstSegment = path.split('/')[0]
      //
      // if (REDIRECT_ROUTES[firstSegment]) {
      //   next(parseRedirect(REDIRECT_ROUTES[firstSegment], to.query))
      //   return
      // }

      next()
    },
    meta: {
      auth: -1,
      titleKey: 'app.notFound.title',
      descriptionKey: 'app.notFound.description',
      // Несуществующий путь отдаётся с index.html и кодом 200 (см. error_page
      // в nginx), поэтому «не индексируй» роботу говорим тегом.
      noindex: true
    },
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  // if (localStorage.getItem('apple') === null && to.name !== 'Apple') {
  //   return next('/code')
  // }
  const slug = to.path.slice(1)

  if (slug) {
    // Динамический конфиг с бэка (stale-while-revalidate)
    const dynamicRedirects = await getRedirectConfig()
    const dynamicTarget = dynamicRedirects && dynamicRedirects[slug]

    if (dynamicTarget) return next('/' + dynamicTarget)

    // Статический fallback из const.ts (если бэк недоступен и кэша нет)
    const staticTarget = REDIRECT_ROUTES[slug]
    if (staticTarget) return next('/' + staticTarget)
  }

  const accessToken = cookie.get('access_token') || store.state.account.accessToken

  if (!cookie.get('access_token')) {
    store.commit('removeAccountData')
  }
  if (accessToken && !store.state.account.userId) {
    store.state.syncCompleted = false
    store.dispatch('authorization', accessToken)
  } else {
    store.state.syncCompleted = true
  }

  if (to.meta.auth === 1) {
    if (accessToken) {
      return next()
    } else {
      return next('/')
    }
  } else if (to.meta.auth === -1) {
    return next()
  }

  next('/')
})

export default router
